import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

export const fetchPoemSurveyAnswers = async ({ patientId, sessionId, signal }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);

  const url = `${__API_URL__}/api/survey/get_survey_answers/?${params.toString()}`;

  const res = await axios.get(url, {
    headers: {
      Authorization: `Token ${token}`,
    },
    signal,
  });

  return res.data || [];
};

const useGetPoemSurveyAnswers = ({ patientId, sessionId, enabled = true }) => {
  return useQuery({
    queryKey: ["survey-answers", patientId, sessionId],
    queryFn: () =>
      fetchPoemSurveyAnswers({
        patientId,
        sessionId,
      }),
    enabled: enabled && Boolean(patientId && sessionId),
  });
};

export default useGetPoemSurveyAnswers;
